// Page: income-threshold  (LMI 60%-of-state-median table)
//
// Shared by two byte-identical inline scripts:
//   Enrollment_modules/info-lmi/income-threshold.module/module.html
//   Enrollment_modules/info-il-lmi/income-threshold.module/module.html
// so one page file serves both (they render on different pages; each carries
// data-ea-module="income-threshold").
//
// Reads the LMI-threshold rows for the stored state from HubDB and renders one
// row per household size, formatting the income + median columns as currency.
//
// DELIBERATE CHANGES (behaviour-preserving):
//   1. HubDB read via core/hubdb `hubdbGetRows('lmiThreshold', { state })`.
//   2. Module-owned selectors (.enrolledAccounts-list .listContent,
//      .enrolledAccounts-listSection, .listContent ul) scoped to `root`.
//   3. The full-page loader stays document-scoped — it intentionally disables
//      every button/anchor on the page and toggles the unique #MEZloaderOverlay /
//      #multienterZipLoader ids (which live outside .enrolledAccounts-main).
//   4. Leftover debug console.log lines dropped.

import { hubdbGetRows } from "../../core/hubdb"
import * as storage from "../../core/storage"

export function init(root: HTMLElement): void {
__ea_trace("modules/savings/income-threshold.ts","init",[root],["root"]);
  /* loader function — page-global (disables all buttons/anchors) */
  function enterZipOpenLoader(): void {
__ea_trace("modules/savings/income-threshold.ts","enterZipOpenLoader",[],[]);
    const loader = document.getElementById("multienterZipLoader") as HTMLElement
    const buttons = document.querySelectorAll<HTMLButtonElement>("button")
    const anchors = document.querySelectorAll<HTMLAnchorElement>("a")
    ;(document.getElementById("MEZloaderOverlay") as HTMLElement).style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/savings/income-threshold.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/savings/income-threshold.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as HTMLAnchorElement & { disabled?: boolean }).disabled = true
    })
  }
  function enterZipcloseLoader(): void {
__ea_trace("modules/savings/income-threshold.ts","enterZipcloseLoader",[],[]);
    const loader = document.getElementById("multienterZipLoader") as HTMLElement
    const buttons = document.querySelectorAll<HTMLButtonElement>("button")
    const anchors = document.querySelectorAll<HTMLAnchorElement>("a")
    ;(document.getElementById("MEZloaderOverlay") as HTMLElement).style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/savings/income-threshold.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/savings/income-threshold.ts","(anon)",[anchor],["anchor"]);
      ;(anchor as HTMLAnchorElement & { disabled?: boolean }).disabled = false
    })
  }
  /* loader function */
  enterZipOpenLoader()

  async function findAssociatedDeals(): Promise<void> {
__ea_trace("modules/savings/income-threshold.ts","findAssociatedDeals",[],[]);
    const stateForLMIConfig = storage.get("stateForLMIConfig")
    const rowsLMIC = await hubdbGetRows("lmiThreshold", {
      state: String(stateForLMIConfig),
    })
    if (rowsLMIC.length >= 1) {
      rowsLMIC.forEach((element) => {
__ea_trace("modules/savings/income-threshold.ts","(anon)",[element],["element"]);
        const values = element.values as Record<string, string>
        const householdSize = values["3"]
        const householdIncome = values["4"]
        const stateMedian = values["5"]
        const stateName = values["2"]
        const contentListSelector = root.querySelector(".enrolledAccounts-list .listContent") as HTMLElement
        const contentList =
          '<ul><li class="list_account">' +
          householdSize +
          '</li><li class="list_name">' +
          householdIncome +
          '</li><li class="list_status">' +
          stateMedian +
          '</li><li class="list_status">' +
          stateName +
          "</li></ul>"
        contentListSelector.innerHTML += contentList
      })

      // Function to format a number as currency
      function formatCurrency(value: string): string {
__ea_trace("modules/savings/income-threshold.ts","formatCurrency",[value],["value"]);
        return (
          "$" +
          parseFloat(value).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        )
      }
      // Get all the ul elements within the div with class 'listContent'
      const ulElements = root.querySelectorAll(".listContent ul")
      // Iterate through each ul element
      ulElements.forEach((ul) => {
__ea_trace("modules/savings/income-threshold.ts","(anon)",[ul],["ul"]);
        // Get the li elements with class 'list_name' and 'list_status'
        const listName = ul.querySelector(".list_name")
        const listStatus = ul.querySelector(".list_status")
        // Format the text content of these li elements
        if (listName) {
          listName.textContent = formatCurrency(listName.textContent ?? "")
        }
        if (listStatus) {
          listStatus.textContent = formatCurrency(listStatus.textContent ?? "")
        }
      })

      enterZipcloseLoader()
      ;(root.querySelector(".enrolledAccounts-listSection") as HTMLElement).style.display = "block"
    }
  }

  findAssociatedDeals()
}
